import { createContext, useContext, useEffect, useState } from "react";

// SUMMARY
/*

popup context is the context that should be used for displaying popups.
It contains the transition feature, back button and closing.

in short, the popup system stores a number of screens (react components) in the screens state variable.

A screen is a javascript object containting the element to render, the offset form the center (0 if it se current -100% if to the right 100% if to the left), 
and an id.

*/

const popupContext = createContext();

export default function PopupProvider({ children }) {
  const [screens, setScreens] = useState([]);
  const [currentScreenId, setCurrentScreenId] = useState(-1);

  useEffect(() => {
    setScreens((prev) =>
      prev.map((s) =>
        s.id !== currentScreenId ? s : { ...s, offset: "0%" }
      )
    );
  }, [currentScreenId]);

  const addScreen = ({ element, offset = "-100%" }) => {
    const id = Math.random();
    setScreens((prev) => [
      ...prev.map((s) => ({ ...s, offset: "-100%" })),
      { id, offset, element },
    ]);
    return id;
  };

  const transitionScreen = ({ element }) => {
    setCurrentScreenId(
      addScreen({
        element,
        offset: screens.length === 0 ? "0%" : "100%",
      })
    );
  };

  const goBack = () => {
    setScreens((prev) => {
      if (prev.length <= 1) {
        setCurrentScreenId(undefined);
        return [];
      }
      const next = prev.slice(0, prev.length - 1);
      setCurrentScreenId(next[next.length - 1].id);
      return next;
    });
  };

  const forceClose = () => {
    setScreens([]);
    setCurrentScreenId(undefined);
  };

  return (
    <>
      <popupContext.Provider
        value={{
          get currentScreen() {
            return screens.find((x) => x.id === currentScreenId);
          },
          screens,
          currentScreenId,
          transitionScreen,
          goBack,

          forceClose,
        }}
      >
        {children}
      </popupContext.Provider>
    </>
  );
}

export function usePopup() {
  return useContext(popupContext);
}
